import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { type StationOut } from "../stations/api";
import { listUnverifiedStations, setStationVerified } from "./adminApi";

export const VERIFICATION_QUEUE_KEY = ["admin", "verification-queue"] as const;

export function useUnverifiedStations(enabled: boolean) {
  return useQuery<StationOut[]>({
    queryKey: VERIFICATION_QUEUE_KEY,
    queryFn: listUnverifiedStations,
    enabled,
    staleTime: 30_000,
  });
}

// Drops the verified station from the cached queue on success so the row
// disappears without a refetch.
export function useVerifyFromQueue() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (stationId) => setStationVerified(stationId, true),
    onSuccess: (_data, stationId) => {
      qc.setQueryData<StationOut[]>(VERIFICATION_QUEUE_KEY, (prev) =>
        prev ? prev.filter((s) => s.id !== stationId) : prev,
      );
    },
  });
}
